import "./drawerView.scss";

import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import { INSPECTOR_MULTIPLE_ITEM_SELECTED } from "../../constants/inspectorMessages";
import { PropTypeShapes } from "../../types";
import { getLabelWithUntitled } from "../../utils/labelUtils";
import preprocessorQuery from "../../utils/preprocessorQuery";
import InspectorField from "../inspector/InspectorField";
import InspectorRow from "../inspector/InspectorRow";
import Icon from "../interface/Icon";
import NavigationToolbar from "../navigationToolbar";
import { asPortalChild } from "../portal/asPortalChild";
import DrawerList from "./DrawerList";

const isIos = preprocessorQuery.isIos();

export default class DrawerView extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      activeIndex: null
    };

    this.onItemClick = this.onItemClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.itemIds.equals(this.props.itemIds)) {
      this.clearActiveIndex();
    }
  }

  renderDrawerList() {
    const isIos = preprocessorQuery.isIos();
    return (
      <DrawerList
        tabs={this.props.tabs}
        activeTab={this.state.activeIndex}
        onClick={this.onItemClick}
        showButtonArrow={isIos}
      />
    );
  }

  clearActiveIndex() {
    this.setState({ activeIndex: null });
  }

  onItemClick(index) {
    this.setState({ activeIndex: index });
  }

  getItemLabelRow() {
    const tab = this.props.tabs[this.state.activeIndex];
    const isMultiple = this.props.itemIds.size > 1;
    return (
      <InspectorRow className="drawerViewItemLabelRow">
        <InspectorField>
          <div className="drawerViewItemLabelContent">
            {isMultiple ? null : <Icon icon="circle-f" color={tab.itemColor} className="mediumDot" />}
            <span className={`drawerViewItemLabel${isMultiple ? " multiple" : ""}`}>
              {isMultiple ? INSPECTOR_MULTIPLE_ITEM_SELECTED : getLabelWithUntitled(tab.itemLabel)}
            </span>
          </div>
        </InspectorField>
      </InspectorRow>
    );
  }

  renderPortal() {
    return asPortalChild(
      <div className="drawerViewWrapper">
        <NavigationToolbar
          title={this.props.tabs[this.state.activeIndex].label}
          showBack={true}
          showBackArrow={true}
          onBackClick={() => this.onItemClick(null)}
          backText={this.props.backText ? this.props.backText : "Back"}
          nextText={"Done"}
          flexLeft={1}
          flexCenter={3}
          flexRight={1}
        />
        <div className="drawerViewBody">
          {isIos ? this.getItemLabelRow() : null}
          {this.props.tabs[this.state.activeIndex].view}
        </div>
      </div>
    );
  }

  renderDrawerView() {
    return (
      <div className="tabViewScrollableContainer" id={this.props.id ? this.props.id : null}>
        {this.props.tabs[this.state.activeIndex].view}
      </div>
    );
  }

  render() {
    const drawerList = this.renderDrawerList();
    let selectedDrawerView = null;
    if (!isNil(this.state.activeIndex)) {
      selectedDrawerView = this.props.allowPortal ? this.renderPortal() : this.renderDrawerView();
    }

    return (
      <div>
        {drawerList}
        {selectedDrawerView}
      </div>
    );
  }
}

DrawerView.propTypes = {
  id: PropTypes.string,
  itemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  tabs: PropTypeShapes.inspectorTabArray.isRequired,
  backText: PropTypes.string,
  allowPortal: PropTypes.bool
};
